<template>
  <div class="d-content">
  <keep-alive>
  <div class="main-container">
    <div>
      <div class="row background">
        <div class="col-4 about">
          <div class="imagePic">
             <img
              :src="employeeData.photo_url"
              class="image"
              alt=""
              v-if="employeeData.photo_url"
            />
            <img
              src="@/assets/user.svg"
              class="image"
              alt=""
              v-if="!employeeData.photo_url"
            />
          </div>
          <div class="aboutDetails">
            <div>
              <p class="empName">{{  employeeData.first_name }} {{ employeeData.last_name }}</p>
            </div>
            <div>
              <p class="empDesignation">{{  employeeData.designation  }}</p>
            </div>
            <!-- <div>
              <button class="editButton">Edit</button>
            </div> -->
          </div>
          <div class="line"></div>
        </div>
        <div class="col-4 quickLinkBtn">
          <button class="linkButton" @click="navigatePayslip()">My Payslips</button>
          <button class="linkButton" @click="navigateItStatement()">My IT Statement</button>
          <!-- <button class="linkButton" @click="navigateCompensation()">My CTC</button> -->
        </div>
        <div class="line"></div>
        <div>
          <div class="dojColum">
            <p class="empDesignation">
              Date of joining : <b>{{ employeeData.date_of_joining  }}</b>
            </p>
            <p class="empDesignation">
              Job Location : <b>{{ employeeData.jobLocation }}</b>
            </p>
            <p class="empDesignation">
              Designation : <b>{{ employeeData.designation }}</b>
            </p>
            <!-- <p v-if="this.le_id!=='e5d057f9-dac4-4fc3-9a31-cdf8d76fbc63' && !showSpecificTenantIds" class="empDesignation">
              Reporting To : <b>{{ employeeData.reportingManager }}</b>!showSpecificTenantIds
            </p> -->
          </div>
        </div>
      </div>
      <div class="twoColumnGridDashboard">
        <div class="">
          <div class="personalInfo">
            <p class="personalHeading">Personal Info</p>
            <div class="lineInfo"></div>
            <div class="attribute-value" v-if="!showSpecificTenantIds">
              <div>First Name:</div>
              <div class="value">{{ employeeData.first_name }}</div>
            </div>
            <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
            <div class="attribute-value" v-if="!showSpecificTenantIds">
              <div>Last Name:</div>
              <div class="value">{{ employeeData.last_name }}</div>
            </div>
            <div class="attribute-value" v-if="showSpecificTenantIds">
              <div>Name:</div>
              <div class="value">{{ employeeData.first_name }}</div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>DOB:</div>
              <div class="value">{{ employeeData.dob }}</div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Mobile Number:</div>
              <div class="value">{{ employeeData.mobile_number }}</div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Email:</div>
              <div class="value">{{ employeeData.email_id }}</div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Aadhar:</div>
              <div class="value">{{ employeeData.adhar_number }}</div>
            </div>
            <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
            <div class="attribute-value" v-if="!showSpecificTenantIds">
              <div>PRAN Number:</div>
              <div class="value">{{ employeeData.pran_number }}</div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>PAN Card No.:</div>
              <div class="value">{{ employeeData.pan_number }}</div>
            </div>
            <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
            <div class="attribute-value" v-if="!showSpecificTenantIds">
              <div>Emergency Contact Name</div>
              <div class="value">{{ employeeData.emergency_contact_name }}</div>
            </div>
            <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
            <div class="attribute-value" v-if="!showSpecificTenantIds">
              <div>Emergency Contact Number:</div>
              <div class="value">
                {{ employeeData.emergency_contact_number }}
              </div>
            </div>
            <div class="linePersonal"></div>
          </div>
          <div class="personalInfo">
            <p class="personalHeading">Address</p>
            <div class="lineInfo"></div>
            <div class="attribute-value">
              <div>Permanent Address:</div>
              <div class="value">{{ permanentAddress }}</div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Communication Address:</div>
              <div class="value">{{ communicationAddress }}</div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="personalInfo">
            <p class="personalHeading">Payment Details</p>
            <div class="lineInfo"></div>
            <div class="attribute-value">
              <div>Mode of Payment:</div>
              <div class="value">
                {{ employeeData.paymentDetails.accounts[1] ?  employeeData.paymentDetails.accounts[1].paymentType : (employeeData.paymentDetails.accounts[0] ?  employeeData.paymentDetails.accounts[0].paymentType : "")}}
              </div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Bank Name:</div>
              <div class="value">
                {{ employeeData.paymentDetails.accounts[1] ? employeeData.paymentDetails.accounts[1].bankName : (employeeData.paymentDetails.accounts[0] ? employeeData.paymentDetails.accounts[0].bankName : '') }}
              </div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Account Number:</div>
              <div class="value">
                {{ employeeData.paymentDetails.accounts[1] ? employeeData.paymentDetails.accounts[1].account_number : (employeeData.paymentDetails.accounts[0] ? employeeData.paymentDetails.accounts[0].account_number : '') }}
              </div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>IFSC:</div>
              <div class="value">
                {{ employeeData.paymentDetails.accounts[1] ? employeeData.paymentDetails.accounts[1].ifsc_code : (employeeData.paymentDetails.accounts[0] ? employeeData.paymentDetails.accounts[0].ifsc_code : '') }}
              </div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Account Type:</div>
              <div class="value">
                {{ employeeData.paymentDetails.accounts[1] ? employeeData.paymentDetails.accounts[1].account_type : (employeeData.paymentDetails.accounts[0] ? employeeData.paymentDetails.accounts[0].account_type : '') }}
              </div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>MICR Code:</div>
              <div class="value">
                {{ employeeData.paymentDetails.accounts[1] ? employeeData.paymentDetails.accounts[1].micr_code : (employeeData.paymentDetails.accounts[0] ? employeeData.paymentDetails.accounts[0].micr_code : '') }}
              </div>
            </div>
            <div class="linePersonal"></div>
            <div class="attribute-value">
              <div>Bank Transfer:</div>
              <div class="value">
                {{ employeeData.paymentDetails.accounts[1] ? employeeData.paymentDetails.accounts[1].bank_transfer_type : (employeeData.paymentDetails.accounts[0] ? employeeData.paymentDetails.accounts[0].bank_transfer_type : '') }}
              </div>
            </div>
            <div class="linePersonal"></div>
          </div>

          <div class="personalInfo">
            <p class="personalHeading">Official Details</p>
            <div class="lineInfo"></div>
            <div class="attribute-value" v-if="!showSpecificTenantIds"> 
            <div>Username:</div>
            <div class="value">{{ employeeData.username }}</div>
          </div>
          <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
          <div class="attribute-value">
            <div>Date of Joining:</div>
            <div class="value">{{ employeeData.date_of_joining }}</div>
          </div>
          <div class="linePersonal"></div>
          <div class="attribute-value">
            <div>Official Email Id:</div>
            <div class="value">{{ employeeData.official_email_id }}</div>
          </div>
          <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
          <div class="attribute-value" v-if="!showSpecificTenantIds">
            <div>Employee Category:</div>
            <div class="value">{{ employeeData.employeeCategory }}</div>
          </div>
          <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
          <div class="attribute-value" v-if="!showSpecificTenantIds">
            <div>Employee Sub Category:</div>
            <div class="value">{{ employeeData.subcategory }}</div>
          </div>
          <div class="linePersonal"></div>
          <div class="attribute-value">
            <div>Cost Center:</div>
            <div class="value">{{ employeeData.costCenter }}</div>
          </div>
          <div class="linePersonal"></div>
          <div class="attribute-value">
            <div>Grade:</div>
            <div class="value">{{ employeeData.grades }}</div>
          </div>
          <div class="linePersonal" v-if="!showSpecificTenantIds"></div>
          <div class="attribute-value" v-if="!showSpecificTenantIds">
            <div>Band:</div>
            <div class="value">{{ employeeData.band }}</div>
          </div>
          <div class="linePersonal"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</keep-alive>
</div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  props: {},
  components: {},
  data() {
    return {
      navList: [
        {
          name: "VPF Settings",
          url: ``
        },
      ],
      employeeData: null,
      role: "",
      employee_id: "",
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },

    showSpecificTenantIds(){
      const le_id = ['dfba4011-0c5e-46cc-b4f4-99f5962f9ebe', 'ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0']
      const client_id = this.employeeData.legal_entity_id
      if(le_id.includes(client_id)){
        return true;
      } else{
        return false;
      }
    },

    permanentAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.permanent_address.addressLineOne == null ? "" : this.employeeData.permanent_address.addressLineOne+","} 
         ${this.employeeData.permanent_address.addressLineTwo == null ? "" : this.employeeData.permanent_address.addressLineTwo+","}
         ${this.employeeData.permanent_address.cityName == null ? "" : this.employeeData.permanent_address.cityName+","} 
         ${this.employeeData.permanent_address.stateName == null ? "" : this.employeeData.permanent_address.stateName} 
         ${this.employeeData.permanent_address.pincode == null ? "" : " - "+this.employeeData.permanent_address.pincode}`;
      }
      return "N/A";
    },

    communicationAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.communication_address.addressLineOne == null ? "" : this.employeeData.communication_address.addressLineOne+","} 
         ${this.employeeData.communication_address.addressLineTwo == null ? "" : this.employeeData.communication_address.addressLineTwo+","}
         ${this.employeeData.communication_address.cityName == null ? "" : this.employeeData.communication_address.cityName+","} 
         ${this.employeeData.communication_address.stateName == null ? "" : this.employeeData.communication_address.stateName} 
         ${this.employeeData.communication_address.pincode == null ? "" : " - "+this.employeeData.communication_address.pincode}`;
      }
      return "N/A"; 
    }

  },
  mounted() {
    this.getEmployeeData();
  },
  methods: {
    ...mapActions({
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      getOrgLeList: "onboard/organization/getOrgLeIdList"
    }),

    async getEmployeeData() {
      try {
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;

        let obj = {
          'employee_id': this.employee_id
        };
        let response = await this.act_getProfileData(obj);
        this.employeeData = response.data.payload[0];
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' }
        this.employeeData.dob = new Intl.DateTimeFormat('en-IN', options).format((new Date(this.employeeData.dob))).split('/').join('-');
        this.employeeData.date_of_joining = new Intl.DateTimeFormat('en-IN', options).format((new Date(this.employeeData.date_of_joining))).split('/').join('-')
        // this.postLock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

     navigateToPf(url){
         this.$router.push({
        path:url
          });
      },

      navigatePayslip(){
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/payrollReports`,
      });
      },

      navigateItStatement(){
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/payrollReports`,
      });
      },

      navigateCompensation(){
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/payrollReports`,
      });
      }

  }
};
</script>
<style lang="scss" scoped>
.background {
  background-color: #f7f7f7;
  height: 165px;
  border-radius: 8px;
}
.editButton {
  padding: 8px 70px 8px 70px;
  background-color: #34c0bd;
  border-radius: 5px;
  color: #f5f5f5;
  font-weight: bold;
}
.image {
  border-radius: 30px;
  padding: 20px;
  height: 155px;
  width: 145px;
}
.about {
  padding-left: 3px;
  display: flex;
  align-items: center;
}
.empName {
  width:160px;
  font-size: 18px;
  font-weight: bold;
  color: #34c0bd;
}
.empDesignation {
  font-size: 11px;
  font-weight: 500;
}

.info{
  padding: 0;
}
.lineModel {
  width: 0.5px;
  height: 85%;
  margin-top: 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}
.lineInfo {
  width: 100%;
  height: 0.5px;
  margin-top: 10px;
  opacity: 0.26;
  border: solid 1px #30b6bc;
}
.linePersonal {
  height: 0.1px;
  opacity: 0.1;
  margin-top: 10px;
  border: solid 1px gray;
  margin-right: 30px;
  margin-left: 25px;
}

.linePersonal:last-child{
  border: none;
}
.quickLinkBtn {
  display: flex;
  flex-direction: column;
  gap: 20px;
  //margin-top: 15px;
  justify-content: center;
  align-items: center;
}
.linkButton {
  color: #376CD6;
  padding: 6px 30px 6px 30px;
  background-color: white;
  border: #30b6bc 1px solid;
  border-radius: 5px;
  font-weight: bold;
  font-size: 1rem;
  width: 72%;
}
.dojColum {
  padding: 20px;
}
.columnTable {
  display: flex;
}
.personalInfo {
  background-color: #f7f7f7;
  border-radius: 8px;
  margin-top: 27px;
  padding-bottom: 10px;
}
.personalInformation {
  padding-left: 20px;
}
.personalHeading {
  padding-top: 10px;
  padding-left: 10px;
  color: #376CD6;
  font-weight: bold;
  font-size: 1.2rem;
}
.tabledata {
  padding-top: 7px;
  font-size: 13px;
}
.attribute-value {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 6px 28px 0px 5px;
  padding-left: 20px;
  font-size: 13px;
  *:nth-child(2n) {
    font-weight: 600;
  }
}
</style>
